import { PageWrapper, PageWrapperProps } from "../../common-ui/PageWrapper";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { AssessmentErrors, useAllAssessments } from "./assessmentUtils";
import { useNavigate } from "react-router-dom";
import { Activity } from "../../API";

const pageDetails: PageWrapperProps = {
  className: "Assessments",
  headerText: "Assessments"
};

export const AssessmentDefinitions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { assessments, status, error } = useAllAssessments();

  const columns: GridColDef[] = [
    {
      field: "title",
      headerName: t("Title"),
      flex: 1
    },
    {
      field: "assessmentSponsor",
      headerName: "Sponsor",
      valueGetter: (params) => params.row.sponsor.name,
      flex: 1
    },
    {
      field: "assessmentInstrument",
      headerName: "Instrument",
      valueGetter: (params) =>
        params.row.instrument.title || AssessmentErrors.NoActivities,
      flex: 1
    },
    {
      field: "assessmentActivities",
      headerName: "Activities",
      valueGetter: (params) => {
        const activities = params.row.activities.items;
        const activityTitles: string = activities
          .map((activity: Activity) => activity.title)
          .join(", ");
        return activityTitles || AssessmentErrors.NoActivities;
      },
      flex: 1
    }
  ];

  return (
    <PageWrapper {...pageDetails}>
      <DataGrid
        aria-label="users-table"
        rows={assessments || []}
        columns={columns}
        loading={status === "loading"}
        localeText={{
          noRowsLabel: t("No assessments exist on the system.")
        }}
        onRowClick={(rowData) => {
          const { row } = rowData;
          const { id } = row;
          if (id) {
            navigate(`${id}`);
          }
        }}
      />
    </PageWrapper>
  );
};
